export default __webpack_public_path__ + "static/brcc-full-width-2-mobile-829ee5ad9fe96f05c352648fd303adea.webp";